import { ReactComponent as CallDown } from "./calldown.svg";
import { ReactComponent as CallOn } from "./callon.svg";
import { ReactComponent as CameraOff } from "./cameraoff.svg";
import { ReactComponent as CameraOn } from "./cameraon.svg";
import { ReactComponent as Close } from "./close.svg";
import { ReactComponent as Cry } from "./cry.svg";
import { ReactComponent as Expand } from "./expand.svg";
import { ReactComponent as Happy } from "./happy.svg";
import { ReactComponent as Link } from "./link.svg";
import { ReactComponent as MicOff } from "./mikeoff.svg";
import { ReactComponent as MicOn } from "./mikeon.svg";
import { ReactComponent as Operator } from "./operator.svg";
import { ReactComponent as Present } from "./present.svg";
import { ReactComponent as Setting } from "./setting.svg";
import { ReactComponent as Shrink } from "./shrink.svg";
import { ReactComponent as Smile } from "./smile.svg";
import { ReactComponent as Thanks } from "./thanks.svg";
import { ReactComponent as Turn } from "./turn.svg";

const icons = {
  CallDown,
  CallOn,
  CameraOff,
  CameraOn,
  Close,
  Cry,
  Expand,
  Happy,
  Link,
  MicOff,
  MicOn,
  Operator,
  Present,
  Setting,
  Shrink,
  Smile,
  Thanks,
  Turn,
};

type Name = keyof typeof icons;

type Props = {
  name: Name;
  size?: number;
  className?: string;
  width?: number;
  height?: number;
};

const DEFAULT_SIZE = 24;

export const Icon = ({
  name,
  size = DEFAULT_SIZE,
  className,
  width,
  height,
}: Props) => {
  const SvgComponent = icons[name];
  width = width ? width : size;
  height = height ? height : size;

  return (
    <SvgComponent
      style={{ height: `${height}px`, width: `${width}px` }}
      className={className}
    />
  );
};
